var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14945 12C2.14945 11.5858 2.48524 11.25 2.89945 11.25H20.8995C21.3137 11.25 21.6495 11.5858 21.6495 12C21.6495 12.4142 21.3137 12.75 20.8995 12.75H2.89945C2.48524 12.75 2.14945 12.4142 2.14945 12Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42973 5.46967C9.72262 5.76256 9.72262 6.23744 9.42973 6.53033L3.96007 12L9.42973 17.4697C9.72262 17.7626 9.72262 18.2374 9.42973 18.5303C9.13683 18.8232 8.66196 18.8232 8.36907 18.5303L2.36908 12.5303C2.07619 12.2374 2.07619 11.7626 2.36908 11.4697L8.36907 5.46967C8.66196 5.17678 9.13683 5.17678 9.42973 5.46967Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowLeft);
export default __webpack_public_path__ + "static/media/black-arrow-left.c7b30293.svg";
export { ForwardRef as ReactComponent };